import styled from 'styled-components'

export const Input = styled.input`
  height: 32px;
  padding: 0 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 32px;
  border: 1px solid var(--color-border, gray);
  border-radius: 6px;
  color: var(--color-text);
  background-color: var(--color-background);
`
